<template>
  <div class="demo">
    <!-- 基本信息 -->
    <div class="forms">
      <div class="formm-title">
        <div>基础信息</div>
      </div>
      <el-form ref="formdata" :model="Entity" label-width="120px" class="formdata">
        <el-form-item label="企业名称" prop="CompanyName">
          <div>{{Entity.CompanyName}}</div>
        </el-form-item>
        <el-form-item label="联系人名称" prop="PeopleName">
          <div>{{Entity.PeopleName}}</div>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="PeopleTel">
          <div>{{Entity.PeopleTel}}</div>
        </el-form-item>
        <el-form-item label="联系人邮箱" prop="PeopleEmail">
          <div>{{Entity.PeopleEmail}}</div>
        </el-form-item>
      </el-form>
      <!-- 企业申报信息 -->
      <div class="formm-title" v-if="Entity.gameDeclareCompanyDeclares[0].DeclareItem">
        <div>企业信息</div>
      </div>
      <div v-if="Entity.gameDeclareCompanyDeclares[0].DeclareItem">
        <div class="box" v-for="(item,index) in Entity.gameDeclareCompanyDeclares" :key="index">
          <div
            class="title"
            style="text-align: center;margin: 0.2px*100 0;font-size: 0.2px*100;font-weight: 600;"
          >项目{{index == 0?'一':index == 1?'二':index == 2?'三':index == 3?'四':'五'}}</div>
          <div class="box-content clearfix">
            <el-form
              :model="Entity"
              :ref="'ruledata'"
              label-width="120px"
              class="demo-ruleForm"
              v-if="item.DeclareItem"
            >
              <el-form-item label="选择申报奖项" class="rider-class" prop="DeclareItem">
                <div>{{item.DeclareItem}}</div>
              </el-form-item>
              <!-- <el-form-item
                label="平台名称"
                prop="PlateformName"
                v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
              >
                <div>{{item.PlateformName}}</div>
              </el-form-item> -->
              <el-form-item
                label="团队或工作室名称"
                prop="JoinCompanyName"
                v-if="item.DeclareItem == '2026年度精选游戏研发团队'"
              >
                <div>{{item.JoinCompanyName}}</div>
              </el-form-item>
              <!-- <el-form-item label="网址" prop="Website" v-if="item.DeclareItem == '2026年度精选游戏研发团队'">
                <div>{{item.Website}}</div>
              </el-form-item>-->
              <el-form-item
                label="所属企业名称"
                prop="BelongCompanyName"
                v-if="item.DeclareItem == '2026年度精选游戏研发团队'"
              >
                <div>{{item.BelongCompanyName}}</div>
              </el-form-item>
              <el-form-item
                :label="item.DeclareItem == '2020年度中国游戏十强游戏产业支持'?'单位名称':'企业名称'"
                prop="JoinCompanyName"
                v-if="item.DeclareItem != '2026年度精选游戏研发团队'"
              >
                <div>{{item.JoinCompanyName}}</div>
              </el-form-item>
              <el-form-item label="所属地区" prop="Province">
                <div>{{item.Province}} {{item.shi}}</div>
              </el-form-item>
              <el-form-item label="人员数量" prop="PeopleNum">
                <div>{{item.PeopleNum}}</div>
              </el-form-item>

              <el-form-item
                :label="item.DeclareItem != '2026年度精选游戏研发团队'?'企业介绍':'团队或工作室介绍'"
                prop="Introduction"
                v-if="item.DeclareItem != '2020年度中国游戏十强游戏产业支持'"
              >
                <div>{{item.Introduction}}</div>
              </el-form-item>
              <!-- <el-form-item
                label="平台网址"
                prop="Website"
                v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
              >
                <div>{{item.Website}}</div>
              </el-form-item> -->
              <el-form-item
                label="单位/媒体介绍"
                prop="Introduction"
                v-if="item.DeclareItem == '2020年度中国游戏十强游戏产业支持'"
              >
                <div>{{item.Introduction}}</div>
              </el-form-item>
              <el-form-item
                label="通过益智、科普、教育、社交互动等玩法体现出游戏的功能性、教育性游戏出版物研发发行等方面有关的工作介绍"
                prop="SocialResponsibility"
                v-if="item.DeclareItem == '2026年度精选社会价值游戏'"
              >
                <div class="editor_txt">{{item.SocialResponsibility}}</div>
              </el-form-item>
              <el-form-item
                v-if="item.DeclareItem == '2026年度精选社会价值游戏'"
                label="提供以上工作的照片或功能性、教育性游戏的视频或图片"
                prop="TeamPhotoID"
                class="picture-card picture-card-video"
              >
                <div v-for="(item, index) in item.TeamPhotoID" :key="index">
                  <video
                    v-if="item.name.indexOf('mp4') != -1 || item.name.indexOf('MP4') != -1 || item.name.indexOf('avi') != -1 || item.name.indexOf('AVI') != -1 || item.name.indexOf('mov') != -1 || item.name.indexOf('MOV') != -1"
                    style="width:160px !important;height:auto !important"
                    controls="controls"
                    :src="getFileUrl(item)"
                  ></video>
                  <img
                    v-else
                    :src="getFileUrl(item)"
                    :preview="Number(12)"
                    alt
                  />
                </div>
              </el-form-item>
              <!-- <el-form-item
                label="参选企业全称"
                prop="JoinCompanyName"
                v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
              >
                <div>{{item.JoinCompanyName}}</div>
              </el-form-item> -->
              <el-form-item
                label="主要产品名称"
                prop="MainProductName"
                v-if="item.DeclareItem == '2026年度精选“走出去”游戏企业'"
              >
                <div>{{item.MainProductName}}</div>
              </el-form-item>
              <el-form-item
                label="产品主要出口国家或地区"
                prop="ProductExportCountry"
                v-if="item.DeclareItem == '2026年度精选“走出去”游戏企业'"
              >
                <div>{{item.ProductExportCountry}}</div>
              </el-form-item>
              <el-form-item
                :label="`${new Date().getFullYear()}年在海外运营收入`"
                prop="ReceiveMoney"
                v-if="item.DeclareItem == '2026年度精选“走出去”游戏企业'"
              >
                <div>{{item.ReceiveMoney}}</div>
              </el-form-item>
              <el-form-item
                :label="item.DeclareItem == '2026年度精选游戏研发团队'?'参选团队或工作室LOGO':item.DeclareItem == '2020年度中国游戏十强游戏产业支持'?'参选单位LOGO':item.DeclareItem == '2026年度精选游戏运营企业'?'参选企业LOGO':'参选企业LOGO'"
                prop="LogoID"
              >
                <template v-if="item.LogoID">
                  <img v-if="item.LogoIDType == 'img'" preview="0" :src="active+'?id='+item.LogoID" class="avatar"/>
                  <img v-else-if="item.LogoIDType == 'ai'" :src="require('../assets/ai.png')" class="avatar"/>
                  <img v-else-if="item.LogoIDType == 'psd'" :src="require('../assets/psd.png')" class="avatar"/>
                </template>
              </el-form-item>
              <el-form-item
                label="团队研发的产品名称"
                prop="ProductExportCountry"
                v-if="item.DeclareItem == '2026年度精选游戏研发团队'"
              >
                <div>{{item.ProductExportCountry}}</div>
              </el-form-item>
              <!-- <el-form-item
                v-if="item.DeclareItem == '2026年度精选游戏研发团队'"
                label="项目组产品LOGO"
                prop="ProductLogoID"
              >
                <img
                  preview="0"
                  v-if="item.ProductLogoID"
                  :src="active+'?id='+item.ProductLogoID"
                  class="avatar"
                />
              </el-form-item> -->
              
              <el-form-item
                :label="item.DeclareItem == '2026年度精选游戏研发团队'?'所属企业营业执照复印件或扫描件':item.DeclareItem == '2020年度中国游戏十强游戏产业支持'?'参选单位营业执照复印件或扫描件':item.DeclareItem == '2026年度精选游戏运营企业'?'参选企业营业执照复印件或扫描件':'参选企业营业执照复印件或扫描件'"
                prop="ZZimgID"
              >
                <img
                  preview="1"
                  v-if="item.ZZimgID"
                  :src="pdfimg ? require('../assets/pdf.jpg') : active+'?id='+item.ZZimgID"
                  class="avatar"
                />
              </el-form-item>
              <el-form-item
                label="举办运营活动的主要产品名称"
                prop="BelongCompanyName"
                v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
              >
                <div>{{item.BelongCompanyName}}</div>
              </el-form-item>
              <el-form-item
                label="近一年围绕产品开展的运营工作介绍"
                prop="Website"
                v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
              >
                <div>{{item.Website}}</div>
              </el-form-item>
              <el-form-item
                v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
                label="运营活动宣传视频或图片"
                prop="TeamPhotoID"
                class="picture-card"
              >
                <div v-for="(item, index) in item.TeamPhotoID" :key="index">
                  <video
                    v-if="checkMediaType(item.name) == 'video'"
                    style="width:160px !important;height:auto !important"
                    controls="controls"
                    :src="getFileUrl(item)"
                    class="avatar"
                  ></video>
                  <img
                    v-if="checkMediaType(item.name) == 'image'"
                    :src="getFileUrl(item)"
                    :preview="Number(15)"
                    :key="index"
                    alt
                  />
                </div>
              </el-form-item>
              <el-form-item
                v-if="item.DeclareItem == '2026年度精选游戏研发团队'"
                label="团队照片"
                prop="TeamPhotoID"
                class="picture-card"
              >
                <img
                  v-for="(item, index) in item.TeamPhotoID"
                  :src="item.url"
                  :preview="Number(15)"
                  :key="index"
                  alt
                />
              </el-form-item>
              <!-- 新增游戏产品中新技术及应用的体现说明 sart -->
              <!-- <el-form-item
                  label="游戏产品中新技术及应用的体现说明"
                  prop="ProductExportCountry"
                  v-if="item.DeclareItem == '2026年度精选游戏科技创新企业' && false"
                >
                  <div>{{item.ProductExportCountry}}</div>
                </el-form-item> -->
                <el-form-item
                  v-if="item.DeclareItem == '2026年度精选游戏科技创新企业' && item.TeamPhotoID.length"
                  label="游戏产品中新技术及应用的体现说明视频"
                >
                  <div v-for="(item, index) in item.TeamPhotoID" :key="index" style="padding-top:10px;">
                    <video
                      v-if="item.name.indexOf('mp4') != -1 || item.name.indexOf('MP4') != -1 || item.name.indexOf('avi') != -1 || item.name.indexOf('AVI') != -1 || item.name.indexOf('mov') != -1 || item.name.indexOf('MOV') != -1"
                      style="width:160px !important;height:auto !important"
                      controls="controls"
                      :src="getFileUrl(item)"
                    ></video>
                  </div>
                </el-form-item>
                <el-form-item
                v-if="item.DeclareItem == '2026年度精选游戏科技创新企业'"
                label="技术专利证明"
              >
                <img
                  preview="1"
                  v-if="item.PlateformInfo"
                  :src="pdfimg ? require('../assets/pdf.jpg') : active+'?id='+item.PlateformInfo"
                  class="avatar"
                />
              </el-form-item>
              <!-- 新增游戏产品中新技术及应用的体现说明 end -->
              <!-- <el-form-item
                label="平台地址账号密码"
                prop="PlateformInfo"
                v-if="item.DeclareItem == '2026年度精选游戏运营企业'"
              >
                <div>{{item.PlateformInfo}}</div>
              </el-form-item> -->
            </el-form>
          </div>
        </div>
      </div>
      <!-- 产品申报信息 -->
      <div class="formm-title" v-if="Entity.GameDeclareWorkInfo[0].DeclareItem">
        <div>产品信息</div>
      </div>
      <div v-if="Entity.GameDeclareWorkInfo[0].DeclareItem">
        <div class="box" v-for="(item,index) in Entity.GameDeclareWorkInfo" :key="index">
          <div
            class="title"
            style="text-align: center;margin: 0.2px*100 0;font-size: 0.2px*100;font-weight: 600;"
          >项目{{index == 0?'一':index == 1?'二':index == 2?'三':index == 3?'四':'五'}}</div>
          <div class="box-content clearfix">
            <el-form :model="item" label-width="120px" class="demo-ruleForm">
              <el-form-item label="选择申报奖项" class="rider-class" prop="DeclareItem">
                <div>{{item.DeclareItem}}</div>
              </el-form-item>
              <el-form-item
                :label="item.DeclareItem== '2020年度中国游戏十强电子竞技游戏'?'产品名称':'产品名称'"
                prop="WorkName"
              >
                <div>{{item.WorkName}}</div>
              </el-form-item>
              <el-form-item label="版号(ISBN)" prop="Isbn">
                <div>{{item.Isbn}}</div>
              </el-form-item>
              <el-form-item
                label="团队名称"
                prop="TeamName"
                v-if="false"
              >
                <div>{{item.TeamName}}</div>
              </el-form-item>
              <el-form-item label="产品介绍" prop="Introduction">
                <div>{{item.Introduction}}</div>
              </el-form-item>
              <el-form-item
                label="产品类型"
                prop="WorkType"
                v-if="item.DeclareItem != '2026年度精选移动游戏' && item.DeclareItem != '2026年度精选游戏运营企业'"
              >
                <div>{{item.WorkType}}</div>
              </el-form-item>
              <el-form-item label="上线时间" prop="InlineTime">
                <div>{{item.InlineTime}}</div>
              </el-form-item>
              <el-form-item label="产品LOGO" prop="LogoID">
                <template v-if="item.LogoID">
                  <img v-if="item.LogoIDType == 'img'" :preview="index+Number(5)" :src="active+'?id='+item.LogoID" class="avatar"/>
                  <img v-else-if="item.LogoIDType == 'ai'" :src="require('../assets/ai.png')" class="avatar"/>
                  <img v-else-if="item.LogoIDType == 'psd'" :src="require('../assets/psd.png')" class="avatar"/>
                </template>
              </el-form-item>
              <el-form-item
                label="产品CG动画"
                prop="CGID"
                v-if="item.DeclareItem !='2020年度中国游戏十强优秀游戏原创剧情奖' && item.DeclareItem != '2020年度中国游戏十强优秀游戏动画表现奖' "
              >
                <video
                  v-if="item.CGID"
                  style="width:160px !important;height:auto !important"
                  controls="controls"
                  :src="active+'?id='+item.CGID"
                  class="avatar"
                ></video>
              </el-form-item>

              <el-form-item
                label="产品实机演示视频"
                prop="FileID"
                v-if="item.DeclareItem !='2026年度精选游戏美术设计' && item.DeclareItem != '2026年度精选游戏音乐设计'"
              >
                <video
                  v-for="(v, idx) in item.FileID" :key="idx"
                  style="width:160px !important;height:auto !important"
                  controls="controls"
                  :src="getFileUrl(v)"
                  class="avatar"
                ></video>
              </el-form-item>

              <el-form-item
                label="产品截图"
                prop="Images"
                class="picture-card"
                v-if="item.DeclareItem != '2026年度精选游戏音乐设计' && item.DeclareItem !='2020年度中国游戏十强优秀游戏原创剧情奖'  && item.DeclareItem != '2020年度中国游戏十强优秀游戏动画表现奖' "
              >
                <img
                  v-for="(items,indexs) in item.Images"
                  :src="items.url"
                  :preview="Number(55)"
                  :key="indexs"
                  alt
                />
              </el-form-item>
              <el-form-item label="近一年围绕产品开展的运营工作介绍" v-if="item.DeclareItem== '2026年度精选游戏运营企业'">
                <div>{{item.GameSportName}}</div>
              </el-form-item>
              <el-form-item
                label="活动宣传视频"
                prop="OtherCG"
                v-if="item.DeclareItem== '2026年度精选游戏运营企业'"
              >
                <video
                  v-if="item.OtherCG"
                  style="width:160px !important;height:auto !important"
                  controls="controls"
                  :src="active+'?id='+item.OtherCG"
                  class="avatar"
                ></video>
              </el-form-item>
              <el-form-item
                label="游戏试玩下载地址及测试账号密码"
                prop="WokeInfo"
              >
                <div>{{item.WokeInfo}}</div>
              </el-form-item>

              <el-form-item
                label="大致月活用户"
                prop="UserPerMonth"
                v-if="item.DeclareItem != '2026年度精选游戏运营企业' && item.DeclareItem !='2026年度精选社会价值游戏' && item.DeclareItem !='2026年度精选中华传统文化游戏' && item.DeclareItem !='2026年度精选游戏美术设计' && item.DeclareItem != '2026年度精选游戏音乐设计' && item.DeclareItem !='2020年度中国游戏十强优秀游戏原创剧情奖'  && item.DeclareItem != '2020年度中国游戏十强优秀游戏动画表现奖' "
              >
                <div>{{item.UserPerMonth}}</div>
              </el-form-item>
              <el-form-item
                label="大致月流水"
                prop="IncomePerMonth"
                v-if="item.DeclareItem != '2026年度精选游戏运营企业' && item.DeclareItem !='2026年度精选社会价值游戏' && item.DeclareItem !='2026年度精选中华传统文化游戏' && item.DeclareItem !='2026年度精选游戏美术设计' && item.DeclareItem != '2026年度精选游戏音乐设计' && item.DeclareItem !='2020年度中国游戏十强优秀游戏原创剧情奖'  && item.DeclareItem != '2020年度中国游戏十强优秀游戏动画表现奖' "
              >
                <div>{{item.IncomePerMonth}}</div>
              </el-form-item>
              <el-form-item
                :label="item.DeclareItem == '2026年度精选游戏音乐设计'?'音乐作品版权或版权授权证明复印件':item.DeclareItem == '2026年度精选游戏美术设计'?'美术作品版权或版权授权证明复印件':'著作权登记证书复印件'"
                prop="GameIsbnPicID"
              >
                <img
                  v-if="item.GameIsbnPicID"
                  :src="pdfimg ? require('../assets/pdf.jpg') : active+'?id='+item.GameIsbnPicID"
                  class="avatar"
                />
              </el-form-item>
              <el-form-item
              class="formitem"
                v-if="item.DeclareItem == '2020年度中国游戏十强优秀原创游戏IP奖'"
                label="提供游戏IP授权或衍生品相关材料"
                prop="FileID"
              >
                <div v-for="file in item.FileID" :key="file.url">
                  <img src="../assets/word.jpg" alt class="avatar" />
                  <div class="accname">{{file.name}}</div>
                </div>
              </el-form-item>
              <el-form-item
               class="formitem formitem_fineart"
                v-if="item.DeclareItem == '2026年度精选游戏美术设计'"
                label="提供产品相关原画集等艺术设计类材料"
                prop="FileID"
              >
                <div class="formitem_box" v-for="file in item.FileID" :key="file.url">
                  <img class="file_img" v-if="file.type && file.type == 'fineArt'" :src="active+'?id='+file.url" alt="">
                  <img v-else src="../assets/word.jpg" alt class="avatar" />
                  <div class="accname">{{file.name}}</div>
                </div>
              </el-form-item>
              <el-form-item
               class="formitem"
                v-if="item.DeclareItem == '2026年度精选游戏音乐设计'"
                label="提供产品的原声集、游戏音效等音频文件"
                prop="FileID"
              >
               <div v-for="file in item.FileID" :key="file.url">
                  <img src="../assets/word.jpg" alt class="avatar" />
                  <div class="accname">{{file.name}}</div>
                </div>
              </el-form-item>
              <el-form-item
               class="formitem"
                v-if="item.DeclareItem == '2020年度中国游戏十强优秀游戏原创剧情奖'"
                label="提供参选游戏原创剧本、文案、背景设定等内容"
                prop="FileID"
              >
                 <div v-for="file in item.FileID" :key="file.url">
                  <img src="../assets/word.jpg" alt class="avatar" />
                  <div class="accname">{{file.name}}</div>
                </div>
              </el-form-item>
              <el-form-item
               class="formitem"
                v-if="item.DeclareItem == '2020年度中国游戏十强优秀游戏动画表现奖'"
                label="申报游戏的动画视频"
                prop="FileID"
              >
                <div v-for="file in item.FileID" :key="file.url">
                  <img src="../assets/word.jpg" alt class="avatar" />
                  <div class="accname">{{file.name}}</div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from "@/config/index.js";
export default {
  props: ["Entity", "pdfimg"],
  data() {
    return {
      // 获取图片
      active: `${baseUrl}/_Framework/GetFile`,
      errorImgSrc: require("../assets/img_error.png"), //图片加载失败时的图片
      loadImgSrc: require("../assets/loading.gif"), //加载中要显示的图片
    };
  },
  methods: {
    isimg(val) {},
    /**
     * 获取文件真实访问地址
     * 视频条目的 url 为视频图标占位图，无法直接播放/展示，
     * 优先从上传响应中取文件 ID 还原真实地址；图片/无响应时回退到原 url
     * @param {Object} item 文件对象
     * @returns {string} 文件真实地址
     */
    getFileUrl(item) {
      if (item && item.response && item.response.Data && item.response.Data.Id) {
        return this.active + "?id=" + item.response.Data.Id;
      }
      return item && item.url ? item.url : "";
    },
    checkMediaType(url) {
      // 获取路径部分（去除参数）
      var path = url;
      // 获取路径的最后一个点之后的内容作为文件扩展名
      var extension = path.split('.').pop().toLowerCase();
      // 声明支持的图片和视频文件扩展名
      var imageExtensions = ['jpg', 'jpeg', 'gif', 'png'];
      var videoExtensions = ['mp4', 'wmv', 'avi', 'mov'];
      // 判断文件扩展名是否在图片扩展名数组中
      if (imageExtensions.includes(extension)) {
        return 'image';
      }
      // 判断文件扩展名是否在视频扩展名数组中
      if (videoExtensions.includes(extension)) {
        return 'video';
      }
      // 扩展名不在图片或视频数组中，返回null表示无法确定媒体类型
      return null;
    },
  },
};
</script>

<style lang="scss">
.formm-title {
  margin-top: 0.36px * 100;
  font-size: 0.2px * 100;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #394859;
  text-align: center;
  position: relative;
  height: 0.3px * 100;
  div {
    position: absolute;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
  }
  &::before {
    content: "";
    display: block;
    width: 0.8px * 100;
    height: 0.06px * 100;
    background: #d8b27e;
    border-radius: 0.04px * 100;
    position: absolute;
    left: 50%;
    bottom: 0.05px * 100;
    transform: translateX(-50%);
  }
}
html::-webkit-scrollbar {
  width: 0;
  height: 0;
  /**/
}
.demo {
  .forms {
    max-width: 7px * 100;
    margin: 0 auto;
  }
  .el-form {
    border-top: 1px solid #dcdfe6;
  }
  .el-form-item {
    border: 1px solid #dcdfe6;
    border-top: none;
    margin-bottom: 0;
  }
  .el-form-item__content {
    margin-left: 1.65px * 100 !important;
    padding-left: 0.2px * 100;
    box-sizing: border-box;
    border-left: 1px solid #dcdfe6;
  }
  .el-form-item__label {
    width: 1.65px * 100 !important;
    text-align: right;
    font-size: 0.14px * 100;
    min-height: 40px;
    display: flex;
    align-items: center;
    // line-height: 0.18px*100;
    padding: 0 0.1px * 100;
    box-sizing: border-box;
    text-align: left;

    font-weight: 400;
    color: #394859;
  }
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2.55px * 100;
    background: rgba(40, 40, 40, 1);
    // border: 0.05px*100 solid rgba(4, 0, 1, 1);
    // box-sizing: content-box;
  }
  //   .dialog-title {
  //     margin-top: -1.2px*100;
  //     font-size: 0.24px*100;
  //     font-family: PingFangSC-Medium, PingFang SC;
  //     font-weight: 500;
  //     color: rgba(247, 209, 148, 1);
  //   }
  // //   .dialog-content {
  // //     padding-top: 0.5px*100;
  // //     box-sizing: border-box;
  // //     text-align: left;

  // //     .el-step__icon.is-text {
  // //       width: 0.45px*100;
  // //       height: 0.45px*100;
  // //       background: #cdc8c0;
  // //       border-radius: 0.27px*100;
  // //       border: 0.03px*100 solid rgba(216, 178, 126, 0.1);
  // //       .el-step__icon-inner {
  // //         font-size: 0.24px*100;
  // //         font-family: FZHTK--GBK1-0, FZHTK--GBK1;
  // //         font-weight: normal;
  // //         color: rgba(255, 255, 255, 1);
  // //       }
  // //     }
  //     .forms {
  //        min-width: 10px*100;
  //         margin:0 auto;
  //       margin-top: 0.4px*100;
  //       .avatar-uploader {
  //         border: 1px solid #dcdfe6;
  //         height: 0.8px*100;
  //         border-radius: 0.04px*100;
  //         padding: 0.1px*100 0.15px*100;
  //         box-sizing: border-box;
  //         .el-upload {
  //           display: flex;
  //           align-items: center;

  //           span {
  //             width: 3.25px*100;
  //             line-height: 1.5;
  //             padding: 0 0.13px*100;
  //             box-sizing: border-box;
  //             text-align: left;
  //             font-size: 0.12px*100;
  //             font-family: PingFangSC-Regular, PingFang SC;
  //             font-weight: 400;
  //             color: rgba(144, 147, 153, 1);
  //           }
  //         }
  //         .avatar-uploader-icon {
  //           width: 0.6px*100;
  //           height: 0.6px*100;
  //           font-size: 0.3px*100;
  //           display: flex;
  //           justify-content: center;
  //           align-items: center;
  //           background: rgba(220, 223, 230, 0.3);
  //           border-radius: 0.02px*100;
  //         }
  //       }
  //       .textarea {
  //         .el-textarea__inner {
  //           height: 1.5px*100;
  //         }
  //       }
  //       .el-form-item__error {
  //         top: 30%;
  //         right: 3%;
  //         left: auto;
  //       }
  //       .el-form-item {
  //         img {
  //           width: 0.6px*100;
  //         }
  //         margin-bottom: 0.12px*100;

  //         .el-form-item__content {
  //           width: 3px*100 !important;
  //           margin-left: 3px*100 !important;
  //           div {
  //             width: 100%;
  //             font-size: 0.16px*100;
  //             font-family: PingFangSC-Medium, PingFang SC;
  //             font-weight: 500;
  //             color: #394859;
  //           }
  //         }
  //       }
  //       .el-input__inner {
  //         width: 4.2px*100;
  //         height: 0.4px*100;
  //         border-radius: 0.04px*100;
  //         border: 1px solid rgba(220, 223, 230, 1);
  //       }
  //     }
  //     .footer-form {
  //       margin-top: 0.3px*100;
  //       display: flex;
  //       justify-content: center;
  //       .el-button {
  //         width: 1.56px*100;
  //         height: 0.42px*100;
  //         background: rgba(216, 178, 126, 1);
  //         border-radius: 0.04px*100;
  //         border: none;
  //         display: flex;
  //         justify-content: center;
  //         align-items: center;
  //         color: #fff;
  //       }
  //     }
  //   }

  // 多文本显示样式
  .editor_txt {
    line-height: 2;
    padding: 10px 10px 10px 0;
    text-align: justify;
  }
  .el-step__line {
    top: 16px !important;
    left: 67%;
    right: -33%;
    background-color: rgba(235, 238, 245, 1) !important;
  }
  .el-step__title {
    margin-top: 0.18px * 100;
    font-size: 0.18px * 100;
    font-family: FZHTK--GBK1-0, FZHTK--GBK1;
    font-weight: normal;
    color: rgba(57, 72, 89, 1);
    line-height: 0.2px * 100;
  }
  .is-process {
    .el-step__icon.is-text {
      background: rgba(216, 178, 126, 1) !important;
    }
  }
  .sbjj {
    margin-left: 120px;
    text-indent: 26px;
    width: 4.2px * 100;
    background: rgba(220, 223, 230, 0.25);
    padding: 10px;
    box-sizing: border-box;
    line-height: 1.5;
    margin-bottom: 0.12px * 100;
  }
  .picture-card {
    .is-success,
    .el-upload-list__item-actions {
      width: 0.6px * 100 !important;
      height: 0.6px * 100 !important;
    }
    .el-upload-list__item {
      width: 0.6px * 100 !important;
      height: 0.6px * 100 !important;
    }
    .el-progress-circle {
      width: 0.6px * 100 !important;
      height: 0.6px * 100 !important;
    }
    .el-form-item__content {
      min-height: auto !important;
      border: none !important;
      width: auto;
      border-radius: 0 !important;
      border-left: 1px solid #ccc !important;

      img {
        margin-right: 0.05px * 100;
        width: 0.6px * 100;
        border: 1px solid #f7f4f4;
        height: auto;
        min-height: 0.3px * 100;
        background: url("../assets/img_loading.gif") no-repeat center center;
        background-size: 20px 20px;
      }
      .card {
        font-size: 0.12px * 100;
        color: rgba(144, 147, 153, 1);
        line-height: 0.14px * 100;
      }
    }
    &-video {
      .el-form-item__label {
        line-height: 2;
        border-right: 1px solid #ccc !important;
      }
      .el-form-item__content {
        display: flex;
      }
    }
  }
  .el-progress {
    width: 0.6px * 100 !important;
    height: 0.6px * 100 !important;
  }
  .footer-active {
    font-size: 0.16px * 100;
    color: rgba(57, 72, 89, 1);
    line-height: 0.14px * 100;
    text-align: center;
    margin-top: 0.2px * 100;
    span {
      color: rgba(216, 178, 126, 1);
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .avatar {
    width: 0.6px * 100 !important;
    height: 0.6px * 100 !important;
    padding: 0.1px * 100;
    background: url("../assets/img_loading.gif") no-repeat center center;
    background-size: 20px 20px;
  }
  .addform {
    text-align: center;
    font-size: 0.16px * 100;
    color: rgba(216, 178, 126, 1);
    cursor: pointer;
    img {
      width: 0.16px * 100;
      margin-right: 0.05px * 100;
      margin-bottom: 0.03px * 100;
    }
    span {
      margin-left: 0.05px * 100;
      font-size: 0.12px * 100;
      color: rgba(144, 147, 153, 1);
      display: inline-block;
    }
  }
}
.pswp {
  z-index: 99999999 !important;
}
.accname{
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100px;
}
.formitem{
  &_fineart {
    .el-form-item__content{
      margin-left: 0 !important;
      padding-left: 0 !important;
    }
  }
  .formitem_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 0.1px * 100;
    .file_img {
      width: 0.6px * 100;
      border: 1px solid #f7f4f4;
      height: auto;
      min-height: 0.3px * 100;
      background: url("../assets/img_loading.gif") no-repeat center center;
      background-size: 20px 20px;
    }
  }
  .el-form-item__content{
    display: flex;
  }
}
</style>